/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CurrencyRateChartPointResponse } from './currency-rate-chart-point-response';


export interface CurrencyRateChartResponse { 
    data: Array<CurrencyRateChartPointResponse>;
}

